import { Component, inject } from '@angular/core';
import { BaryModalEvent, IBaryModalEvent } from 'models/bary-modal-event';
import { BaryComponentHelper } from 'app/shared/util/bary-component-helper';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { FaDirectiveEnum } from '../../../../../../models/enums/fa-directive.enum';

@Component({
  templateUrl: './bary-modal-confirm.component.html',
})
export class BaryModalConfirmComponent {
  readonly #modalRef = inject(MDBModalRef);

  public action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  public title?: string;
  public message?: string;
  public icon?: string;
  public buttons = {
    submit: '',
    second: '',
  };
  public class = '';

  protected readonly FAS = FaDirectiveEnum.FAS;

  public handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.#modalRef.hide();
  }
}
